var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-container',{staticClass:"app-wrapper"},[_c('el-header',{attrs:{"height":"58"}},[_c('navbar')],1),_c('el-container',{staticClass:"main-container"},[(!_vm.sideBar)?_c('div',{staticClass:"mask-layer",on:{"click":_vm.handleCloseClick}}):_vm._e(),_c('sidebar',{ref:"sidebar"}),_c('router-view',{key:_vm.key})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }